import React, { useEffect } from 'react'
import './InvoiceForOG.css'

function InvoiceForOG() {
    const invoiceData = JSON.parse(sessionStorage.getItem('invoiceData'));
    console.log("invoiceData",invoiceData);
    const { ItemData, HeaderData } = invoiceData;
    
    // Calculate total amount
    const totalAmount = ItemData.reduce((sum, item) => sum + (item.Amount || 0), 0);
    
    const handlePrint = () => {
        window.print();
    };
    
    // Auto print after component mounts and data is loaded
    useEffect(() => {
        // Small delay to ensure DOM is fully rendered
        const timer = setTimeout(() => {
            window.print();
        }, 1000);
        
        return () => clearTimeout(timer);
    }, []);
    
  return (
    <div className='page-content'>
      <div className="invoice-container">
        <div className="invoice-header">
          <h1 className="company-name">BHAGIRATH PACKAGING INDUSTRIES</h1>
          <div className="header-info">
            <div className="party-info">
              {HeaderData && HeaderData[0] && HeaderData[0].LedgerName}
            </div>
            <div className="date-info">
              {HeaderData && HeaderData[0] && HeaderData[0].VoucherDate}
            </div>
          </div>
        </div>
        
        <div className="invoice-table">
          <table>
            <thead>
              <tr>
                <th>Style</th>
                <th>Sheet Size</th>
                <th>Name</th>
                <th>Ply</th>
                <th>PR</th>
                <th>Challan No.</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {ItemData && ItemData.map((item, index) => (
                <tr key={index}>
                  <td>{item.CodeNo || ''}</td>
                  <td>{item.SheetSize}</td>
                  <td>{item.Name}</td>
                  <td>{item.Ply}</td>
                  <td>{item.PR}</td>
                  <td>{item.ChallanNoL}</td>
                  <td className="number-cell">{item.Qty?.toFixed(2)}</td>
                  <td className="number-cell">{item.Rate?.toFixed(2)}</td>
                  <td className="number-cell">{item.Amount?.toFixed(2)}</td>
                </tr>
              ))}
              <tr className="total-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="total-label">Total</td>
                <td className="total-amount">{totalAmount.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div className="print-button-container">
        <button className="print-button" onClick={handlePrint}>
          <i className="fas fa-print"></i>
          Print
        </button>
      </div>
    </div>
  )
}

export default InvoiceForOG